import { Terms } from '../../components/service/accounts/PrivacyTerms';
import { useTermsData } from '../../services';
export const TermsPageView = () => {
  const terms = useTermsData();
  if (!terms.isSuccess) {
    return <></>;
  }
  return <Terms data={terms.data} data-sentry-element="Terms" data-sentry-component="TermsPageView" data-sentry-source-file="terms.tsx" />;
};